import React from "react";
import { Box, Typography } from "@mui/material";
import { useContent } from "../context/ContentContext";

export default function About() {
  const content = useContent();
  const company = content.getCompany();
  return (
    <Box
      id="about"
      sx={{
        width: "100vw",
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw",
        mt: -4, // Add this line to pull About section up
      }}
    >
      {/* --- Welcome Block --- */}
      <Box textAlign="left" mb={6} sx={{ width: "100%", px: { xs: 2, md: 8 } }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, fontSize: { xs: "1.8rem", md: "3.5rem" } }}>
          Welcome to{" "}
          <Box component="span" sx={{ fontWeight: "normal", fontSize: { xs: "1.8rem", md: "2.5rem" } }}>
            {company.name}
          </Box>
        </Typography>
        <Typography variant="h6" sx={{ color: "text.secondary", mb: 2 }}>
          {company.tagline}
        </Typography>
      </Box>
    </Box>
  );
}